import React, { useEffect, useState } from "react";
import app from "nystem";
import ReactDOM from "react-dom";
import { ContentTypeView } from "nystem-components";

const TinymcePortal = () => {
  const [portals, setPortals] = useState([]);

  useEffect(() => {
    let portals = [];

    const reactPortal = ({ id, Component, element, viewId }) => {
      portals = portals.filter(({ id: itemId }) => id !== itemId);

      if (Component) portals = [...portals, { id, Component, element, viewId }];

      setPortals(portals);
    };

    const reactPortalViewClose = ({ id }) => {
      portals = portals.filter(({ viewId }) => id !== viewId);

      setPortals(portals);
    };

    app.on(`reactPortal`, reactPortal);
    app.on(`reactPortalViewClose`, reactPortalViewClose);
    return () => {
      app.off(`reactPortal`, reactPortal);
      app.off(`reactPortalViewClose`, reactPortalViewClose);
    };
  }, []);

  if (portals.length)
    return portals.map(({ id, Component, element }) => ReactDOM.createPortal(<Component />, element, id));

  return null;
};

export default TinymcePortal;

// eslint-disable-next-line no-unused-expressions
customElements.get("nystem-component") ||
  customElements.define(
    "nystem-component",
    class extends HTMLElement {
      constructor() {
        super();
        this.portalId = app.uuid();
      }

      async connectedCallback() {
        const value = this.getAttribute("value");
        const settings = {
          contentType: this.getAttribute("contenttype"),
          format: this.getAttribute("format"),
          value: value && JSON.parse(value.replace(/'/g, '"')),
        };

        let element = this.attachShadow({ mode: "open" });

        this.timer = setTimeout(async () => {
          // eslint-disable-next-line prefer-const
          let { Component, baseView } = await app.event(`tinymceComponent`, {
            ...settings,
            viewId: this.closest(".tinymceview").id,
            element,
            setValue: (value) =>
              value
                ? this.setAttribute("value", JSON.stringify(value).replace(/"/g, "'"))
                : this.parentElement.removeChild(this),
          });

          if (!Component || !this.closest(".tinymceinput")) {
            const reactRoot = document.createElement("div");
            reactRoot.style.display = "contents";
            element.appendChild(reactRoot);
            element = reactRoot;

            Component = () => {
              useEffect(() => {
                this.viewUnmount = true;
                if (this.parentElement && !this.closest(".tinymceinput"))
                  this.parentElement.replaceChild(element, this);
              }, []);

              return <ContentTypeView {...settings} baseView={baseView} />;
            };
          }

          app.event(`reactPortal`, { id: this.portalId, Component, element, viewId: this.closest(".tinymceview").id });
        }, 20);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        if (!this.viewUnmount) app.event(`reactPortal`, { id: this.portalId });
      }
    },
  );
